<!-- eslint-disable max-len -->
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    height="25"
    width="25"
    viewBox="-120 20 500 260"
  >
    <path
      d="M282.717,90.903l-65.223-65.222c-13.443-13.444-34.023-15.498-49.656-6.175L151.253,2.921  c-3.896-3.894-10.209-3.894-14.105,0c-3.895,3.895-3.895,10.21,0,14.105L153.721,33.6c-3.742,6.245-5.74,13.406-5.74,20.875  c0,10.878,4.236,21.103,11.927,28.793l25.558,25.558l-7.636,7.636l-2.554-2.554c-5.124-5.125-11.937-7.948-19.186-7.948  c-7.248,0-14.061,2.823-19.185,7.947L21.023,229.79c-5.518,5.517-8.91,12.605-9.553,19.96c-0.691,7.893,1.944,15.451,7.228,20.734  L37.913,289.7c4.894,4.893,11.429,7.3,18.215,7.3c7.884,0,16.107-3.25,22.481-9.624l115.883-115.883  c10.578-10.579,10.578-27.791,0-38.371l-2.555-2.555l7.635-7.635l25.558,25.558c1.948,1.947,4.5,2.921,7.053,2.921  s5.105-0.974,7.053-2.921l43.481-43.481C286.612,101.113,286.612,94.798,282.717,90.903z M180.387,157.388L64.503,273.27  c-3.945,3.944-9.778,5.032-12.485,2.324l-19.215-19.215c-1.512-1.512-1.565-3.714-1.462-4.892c0.232-2.65,1.611-5.417,3.786-7.591  l115.883-115.884c1.357-1.357,3.161-2.104,5.079-2.104c1.92,0,3.724,0.747,5.08,2.105l19.216,19.214  C183.188,150.028,183.188,154.587,180.387,157.388z M232.183,127.331l-58.17-58.169c-3.923-3.923-6.084-9.139-6.084-14.688  c0-5.546,2.159-10.76,6.079-14.683c0.002-0.002,0.004-0.003,0.005-0.005c0.001-0.001,0.003-0.003,0.004-0.005  c4.05-4.046,9.366-6.069,14.684-6.069c5.319,0,10.639,2.025,14.688,6.074l58.169,58.169L232.183,127.331z"
      :fill="pathFill"
    />
  </svg>
</template>

<script>
export default {
  props: {
    pathFill: {
      type: String,
      default: '#FFFFFF',
    },
  },
};
</script>
